import { render, staticRenderFns } from "./PolTypeSchemeReview.vue?vue&type=template&id=ba232746&"
import script from "./PolTypeSchemeReview.vue?vue&type=script&lang=js&"
export * from "./PolTypeSchemeReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports